import styles from './GlobalSpinner.module.scss';

export const GlobalSpinnerSizeMapping = {
	s: styles.s,
	m: styles.m,
	l: styles.l,
	xl: styles.xl,
	container: styles.container,
};

export type GlobalSpinnerSize = keyof typeof GlobalSpinnerSizeMapping;
